<p-multiSelect
  [options]="comparisonValues"
  [(ngModel)]="selection"
  placeholder="Vergleichswert auswählen"
  optionLabel="name"
  optionValue="key"
  display="chip"
  (ngModelChange)="onSelectionChange($event)"
  [showClear]="true" />
